export async function compressImageTo1MB(file) {
    if (!file.type.startsWith('image/'))
        throw new Error('Only image files are supported.');
    const imageBitmap = await createImageBitmap(file);
    const canvas = document.createElement('canvas');
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(imageBitmap, 0, 0);
    let quality = 0.9;
    let blob = null;
    // Try reducing quality until under 1MB or minimum quality
    while (quality > 0.1) {
        blob = await new Promise((resolve) => canvas.toBlob((b) => resolve(b), file.type === 'image/png' ? 'image/png' : 'image/jpeg', quality));
        if (blob && blob.size <= 1024 * 1024)
            break;
        quality -= 0.1;
    }
    if (!blob)
        throw new Error('Compression failed.');
    return new File([blob], file.name, { type: blob.type });
}
